const mergeWithDynamic = (staticData, dynamicCards) => {
  return staticData.map(card => {
    const dynamic = dynamicCards.find(d => d.cardId === card.cardId);
    if (dynamic) {
      card.moreLinks = dynamic.moreLinks;
    }
    return card;
  });
};

export default mergeWithDynamic;
